<template>
    <a
        :class="['btn button continue-button', { expired: ctaEvent, disabled: ctaDisabled }]"
        @click="ctaEvent ? emitEvent(ctaEvent) : goToOffer(offer)"
    >
        <span> {{ ctaText }} </span>
    </a>
</template>

<script>
import Bugsnag from '@bugsnag/js'
import { useRoute } from 'vue-router'

import get from 'lodash/get'

export default {
    props: ['offer', 'isOfferExpired', 'resubmitEnabled', 'isCreditCardCampaign', 'expired', 'offerIndex'],
    inject: ['application_id'],
    setup() {
        const route = useRoute()

        return {
            route,
        }
    },
    data() {
        return {
            ctaEvent: null,
            ctaDisabled: false,
            ctaPayload: {},
        }
    },
    methods: {
        goToOffer: function (offer) {
            let utmContent = this.$router.currentRoute._value.query.day || false
            let utmCampaign = this.$router.currentRoute._value.query.cid || false

            this.trackOfferClick(offer)

            if (utmContent) {
                window.open(`${offer.cta.url}&utm_source=email&utm_content=${utmContent}&utm_campaign=${utmCampaign}`)
            } else {
                window.open(offer.cta.url)
            }
        },
        emitEvent: function (eventName, payload) {
            this.emitter.emit(eventName, {})
            this.$nextTick(() => this.emitter.emit('scrollToResubmitForm', {}))
        },
        trackOfferClick: function (offer) {
            try {
                this.trackEvent('pageview', {
                    virtualPageView: `${this.route.fullPath}/offer/${offer.id}`,
                    route: `${this.route.fullPath}/offer/${offer.id}`,
                })

                this.trackEvent('event', {
                    eventCategory: 'offer',
                    eventAction: 'click',
                    eventLabel: offer.type,
                    eventValue: offer.monthly_repayment || offer.fees,
                })

                this.trackEvent('event', {
                    eventCategory: 'offer',
                    eventAction: 'position',
                    eventLabel: `${this.offerCount} - ${this.offerIndex + 1}`,
                    eventValue: offer.monthly_repayment,
                })

                let providerEntity = get(offer, 'lender.provider_entity', null)
                let productName = get(offer, 'lender.name', null)

                this.trackEvent('offer_click', {
                    application_id: this.application_id,
                    offerID: offer.id,
                    providerEntity: providerEntity ? providerEntity : productName,
                    productName: productName,
                    sortIndex: this.offerIndex + 1,
                })
            } catch (err) {
                Bugsnag.notify(err)
            }
        },
    },
    computed: {
        ctaText: function () {
            this.ctaEvent = null

            if (this.isOfferExpired && this.resubmitEnabled) {
                if (!this.isCreditCardCampaign) {
                    this.ctaEvent = 'resubmit'
                    this.ctaPayload = {}
                } else {
                    this.ctaEvent = 'refreshOffer'
                    this.ctaPayload = { result: this }
                }

                return this.$t('results.heroBanner.buttons.updateSearch')
            } else if (this.expired || this.isOfferExpired) {
                this.ctaDisabled = true
                return this.$t('results.expired')
            }

            return this.offerButtonText
        },
        offerButtonText: function () {
            if (this.offer.type === 'debt_solution' && this.territory === 'gbr') {
                return this.$t('results.offerBlock.debtSolution.buttons.cta')
            }

            return this.$store.state.global.page.button_text || this.offer.cta.label
        },
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.continue-button {
    line-height: rem(40px);
    height: 40px;
    margin-bottom: 0px;

    @media screen and (min-width: $bp-medium) {
        margin-bottom: 30px;
    }
}
</style>
